// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Sicoob — COMPE 756 */
export const Sicoob = createBankIcon({
  name: "Sicoob",
  slug: "sicoob",
  compe: "756",
  color: "#003641",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#003641;fill-opacity:1\"\n     id=\"sicoob_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(21.0155,24.4622) scale(0.46042)\">\n    <path d=\"m6.2836 0.039757a7.2336 7.2336 0 0 0-2.8668 0.8667 6.8169 6.8169 0 0 0-3.4168 5.9335 7.0669 7.0669 0 0 0 0.71669 3.0834l33.634 58.452 10.9-18.851 17.734-30.701-10.867-18.784z\" style=\"fill:#72bf44\" />\n    <path d=\"m52.118 0.039757 28.601 49.435h21.667l22.917-39.701a6.8002 6.8002 0 0 0-5.7835-9.7337z\" style=\"fill:#00ae9d\" />\n    <path d=\"m100.82 49.475h-55.569l-10.9 18.901 23.001 39.668a7.2169 7.2169 0 0 0 2.2001 2.0001 6.6669 6.6669 0 0 0 3.4168 0.9167 6.8836 6.8836 0 0 0 5.7169-3.0834l33.768-58.335z\" style=\"fill:#bfd730\" />\n  </g>",
});
